// extracted by mini-css-extract-plugin
export default {"special-text":"BiographyTemplate_special-text__qA8PV"};